import { Theme, makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => {
  return {
    labelStylePerPage: {
      fontSize: theme.typography.pxToRem(15),
      paddingTop: theme.spacing(5.5),
      paddingLeft: theme.spacing(8),
      '& .MuiGrid-spacing-xs-2': {
        paddingTop: theme.spacing(3.5),
      },
    },
    valueStyle: {
      paddingTop: theme.spacing(3.5),
    },
    valueStylePerPage: {
      paddingTop: theme.spacing(3.5),
      paddingRight: theme.spacing(0.5),
    },
    paddingGrid: {
      paddingBottom: theme.spacing(5),
    },
    bgColor: {
      '& .MuiSelect-select': {
        border: 'none',
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    checkBoxLabelCss: {
      paddingTop: theme.spacing(2.5),
      fontWeight: 900,
      textAlign: 'left',
    },
    textAlignCss: {
      verticalAlign: 'super',
      fontSize: theme.typography.pxToRem(18),
    },
    removeMarginTop: {
      marginTop: theme.spacing(0),
    },
    checkBoxLabelCssLink: {
      color: theme.palette.primary.main,
    },
    borderCss: {
      border: `1px solid ${theme.palette.grey[500]}`,
      padding: theme.spacing(1.5, 2.5, 1.5, 2.5),
      borderBottom: 'none',
    },
    instructionLabelCss: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 900,
      textAlign: 'left',
    },
    uploadInstructionLabelCss: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 900,
      textAlign: 'left',
    },
    instructionCss: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 'normal',
      textAlign: 'left',
      color: theme.palette.text.primary,
      paddingBottom: theme.spacing(7),
    },
    optionCss: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 'normal',
      textAlign: 'left',
      color: theme.palette.text.primary,
    },
    optionLabelCss: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 900,
      textAlign: 'left',
    },
    manualSearchLabelCss: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 900,
      textAlign: 'left',
      padding: theme.spacing(6.5, 0, 8.5, 0),
    },
    downloadContainerCss: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 900,
      textAlign: 'left',
      padding: theme.spacing(5, 0, 0, 0),
    },
    manualSearchLinkCss: {
      color: theme.palette.primary.main,
    },
    geneIdLinkCss: {
      paddingLeft: theme.spacing(3),
    },
    labelColorCss: {
      color: theme.palette.primary.main,
    },
    divider: {
      height: theme.spacing(80),
      marginLeft: theme.spacing(9),
      width: '2px',
    },
    gridPadding: {
      padding: theme.spacing(5.5, 6, 7, 5.5),
      border: `1px solid ${theme.palette.grey[500]}`,
    },
    manualSearchDivider: {
      height: theme.spacing(5.5),
      width: '2px',
      display: 'inline-block',
      margin: theme.spacing(0, 6),
    },
    downloadIdDivider: {
      height: theme.spacing(4.5),
      width: '2px',
      display: 'inline-block',
      margin: theme.spacing(0.5, 3),
    },
    geneSymDivider: {
      height: theme.spacing(5),
      marginLeft: theme.spacing(0),
      width: '2px',
    },
    refSeqDivider: {
      height: theme.spacing(5),
      marginLeft: theme.spacing(5),
      width: '2px',
    },
    nextButton: {
      marginTop: theme.spacing(4),
      minWidth: 220,
      height: theme.spacing(12),
    },
    buttonconfig: {
      marginTop: theme.spacing(3.5),
      marginBottom: theme.spacing(3.5),
    },
    disableLink: {
      color: theme.palette.common.black,
    },
    divCss: {
      width: '100%',
    },
    filterBorderCss: {
      border: `1px solid ${theme.palette.grey[500]}`,
      padding: theme.spacing(6, 6.25, 0, 6.25),
      borderBottom: 'none',
    },
    primersBorderCss: {
      border: `1px solid ${theme.palette.grey[500]}`,
      padding: theme.spacing(0, 5, 0, 2.5),
      borderBottom: 'none',
    },
    filterLableCss: {
      '& label': {
        padding: theme.spacing(5.5, 0, 1.5, 0),
        fontSize: theme.typography.pxToRem(16),
        width: 'fit-content',
        fontWeight: 900,
        textAlign: 'left',
      },
      '& .MuiInput-root': {
        width: '75%',
        '& .MuiSelect-root': {
          height: 40,
          lineHeight: theme.typography.pxToRem(30),
        },
      },
    },
    step2HeaderCss: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 900,
      textAlign: 'left',
    },
    lightGreyFont: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      paddingRight: theme.spacing(2),
    },
    perPagePadding: {
      padding: theme.spacing(6, 0, 3),
    },
    idMargin: {
      color: theme.palette.primary.main,
      fontWeight: 900,
      fontSize: theme.typography.pxToRem(12),
      marginRight: theme.spacing(0),
    },
    bgColorForTableHeader: {
      backgroundColor: theme.palette.background.grey,
    },
    tableHeaderCss: {
      fontSize: theme.typography.pxToRem(12),
      paddingRight: theme.spacing(2),
    },
    paginationPadding: {
      paddingTop: theme.spacing(8),
      paddingRight: theme.spacing(50),
    },
    perPagePaddingGrid: {
      padding: theme.spacing(5, 0, 0, 0),
    },
    dataFontSize: {
      fontSize: theme.typography.pxToRem(14),
    },
    containerPadding: {
      paddingLeft: theme.spacing(2.5),
      paddingTop: theme.spacing(2),
    },
    searchErrorBarPadding: {
      paddingTop: theme.spacing(2),
    },
    searchSectionIdCss: {
      display: 'inline-block',
      '& div': { display: 'inline-block', verticalAlign: 'super' },
      padding: theme.spacing(5, 0),
    },
    downloadLinkCss: {
      display: 'inline-block',
      '& div': { display: 'inline-block', verticalAlign: 'super' },
    },
    expandIconCss: {
      position: 'relative',
      top: '5px',
      color: theme.palette.primary.main,
      '& .MuiSvgIcon-root': {
        width: theme.spacing(4),
        height: theme.spacing(4),
      },
    },
    removeMarginRight: {
      marginRight: theme.spacing(0),
    },
    manualSearchText: {
      resize: 'none',
      fontFamily: 'inherit',
      '& textarea': {
        overflow: 'auto',
      },
    },
    cardWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(6, 5, 0),
      marginBottom: theme.spacing(4),
      borderRadius: 0,
      paddingBottom: theme.spacing(0),
      boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    },
    OrderSubHeadCss: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
    },
    OrderHeaderCss: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: theme.spacing(1, 0),
    },
    dFlex: {
      display: 'flex',
    },
    cardContent: {
      padding: theme.spacing(0),
      paddingRight: theme.spacing(0),
      paddingBottom: theme.spacing(0),
    },

    deleteMargin: {
      marginLeft: theme.spacing(5),
      marginRight: theme.spacing(9.25),
    },

    deleteButton: {
      padding: theme.spacing(0),
    },
    deleteAllText: {
      fontSize: theme.typography.pxToRem(16),
    },
    sequenceInfo: {
      fontSize: theme.typography.pxToRem(16),
      paddingTop: theme.spacing(2.5),
    },
    priceStyle: {
      fontSize: theme.typography.pxToRem(16),
      paddingLeft: theme.spacing(17),
      paddingTop: theme.spacing(2.5),
    },
    alignRight: {
      textAlign: 'right',
    },
    sequenceProperties: {
      width: '30%',
      paddingLeft: theme.spacing(15),
      '& + td': {
        paddingLeft: theme.spacing(1),
      },
    },
    tableBodyPadding: {
      paddingLeft: theme.spacing(3),
    },

    deleteIcon: {
      fontSize: theme.typography.pxToRem(22),
      color: theme.palette.grey[400],
    },
    contentWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(5),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(5),
    },

    summaryNoteCss: {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(12),
      paddingBottom: theme.spacing(0),
      paddingRight: theme.spacing(1),
    },

    listTypePadding: {
      padding: theme.spacing(0, 0, 10, 0),
    },
    marginNote: {
      marginLeft: theme.spacing(0.75),
    },

    head: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(0, 0, 4),
    },
    button: {
      marginTop: theme.spacing(0),
      minWidth: '100%',
    },
    listPadding: {
      paddingLeft: theme.spacing(5),
      paddingTop: theme.spacing(2),
      fontSize: theme.typography.pxToRem(12),
    },
    subListPadding: {
      paddingBottom: theme.spacing(2),
    },
    summarySubHead: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightMedium,
      margin: theme.spacing(3, 0, 4),
    },
    subPrice: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightMedium,
      margin: theme.spacing(3, 0, 4),
      textAlign: 'right',
    },
    Summarydivider: {
      marginTop: theme.spacing(-3),
    },
    leftPadding: {
      marginLeft: theme.spacing(112.5),
    },
    subTotal: {
      fontSize: theme.typography.pxToRem(12),
    },
    paddingLeftDelete: {
      paddingLeft: theme.spacing(30),
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(3),
    },
    kicqstartProbeTableContainer: {
      overflowX: 'hidden',
    },
    kicqstartProbeScrollBar: {
      maxHeight: 850,
      overflowX: 'hidden',
    },
    sirnaNoLabel: {
      paddingLeft: theme.spacing(19.6),
    },
    shippingfontWeight: {
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(16),
      paddingBottom: theme.spacing(5),
      paddingRight: theme.spacing(1),
    },
    shippingbody: {
      fontSize: theme.typography.pxToRem(12),
      bottomPadding: theme.spacing(3),
    },
    ambientPadding: {
      fontSize: theme.typography.pxToRem(16),
    },
    shippingNote: {
      marginBottom: theme.spacing(5),
      fontSize: theme.typography.pxToRem(12),
    },
    summaryDescPadding: {
      paddingRight: theme.spacing(2.5),
    },
    primersTableContainer: {
      overflowX: 'hidden',
      '& .MuiTableCell-root': {
        padding: theme.spacing(0),
      },
    },
    primersScrollBar: {
      maxHeight: 790,
      overflowX: 'hidden',
      '& .MuiTableCell-root': {
        padding: theme.spacing(0),
      },
    },
    primersBgColor: {
      '& .MuiSelect-select': {
        border: 'none',
        fontWeight: theme.typography.fontWeightMedium,
        paddingRight: theme.spacing(0),
      },
    },
    tableBorderCss: {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderTop: 'none',
      padding: theme.spacing(0, 6.25, 6, 6.25),
    },
    tableContainerPadding: {
      paddingLeft: theme.spacing(2.5),
    },
    errorMsgStyle: {
      textAlign: 'left',
      fontSize: theme.typography.pxToRem(16),
      borderRadius: theme.spacing(0),
      padding: theme.spacing(6, 0, 6, 0),
      marginTop: theme.spacing(2.5),
      width: '100%',
    },
    confirmOrderBorderCss: {
      border: `1px solid ${theme.palette.grey[500]}`,
      padding: theme.spacing(6, 6.25, 0, 6.25),
    },
    paddingLeftPrimers: {
      padding: theme.spacing(1, 4, 1, 1),
      wordBreak: 'break-word',
    },
    searchTextPadding: {
      padding: theme.spacing(5, 5, 12.5, 5),
      border: `1px solid ${theme.palette.grey[500]}`,
      borderTop: 'none',
    },
    searchTextFontWeight: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightRegular,
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(-2),
    },
    uploadQueriesBorderPadding: {
      padding: theme.spacing(5, 5, 5, 5),
      border: `1px solid ${theme.palette.grey[500]}`,
      borderTop: 'none',
    },
    savrcoPadding: {
      paddingTop: theme.spacing(2.5),
      paddingLeft: theme.spacing(2.5),
      border: `1px solid ${theme.palette.grey[500]}`,
      borderTop: 'none',
      borderBottom: 'none',
    },
    primersContainerPadding: {
      paddingLeft: theme.spacing(2.5),
    },
    searchArrayBox: {
      border: `${theme.spacing(0.25)}px solid ${theme.palette.grey[400]}`,
      width: 880,
      margin: `${theme.spacing(0)}px ${theme.spacing(0)}px ${theme.spacing(
        0
      )}px ${theme.spacing(5)}px`,
      padding: `${theme.spacing(10)}px ${theme.spacing(8)}px ${theme.spacing(
        8
      )}px ${theme.spacing(10)}px`,
      height: 300,
    },
    width300: {
      width: theme.spacing(75),
      '& .makeStyles-icon-636': {
        top: '0 !important',
      },
    },
    whiteColor: {
      backgroundColor: theme.palette.common.white,
    },
    marginTop10: {
      marginTop: theme.spacing(10),
    },
    marginTop6: {
      marginTop: theme.spacing(6),
    },
    textAlignRight: {
      textAlign: 'right',
    },
    searchButton: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(2.5, 12.5),
    },
    deleteMarginGeneArrays: {
      marginLeft: theme.spacing(5),
      marginRight: theme.spacing(9),
    },
    filterLableCssPrimers: {
      '& label': {
        padding: theme.spacing(1, 1, 0, 0),
        fontSize: theme.typography.pxToRem(16),
        width: 'fit-content',
        fontWeight: 900,
        textAlign: 'left',
      },
      '& .MuiInput-root': {
        width: '75%',
        '& .MuiSelect-root': {
          height: 40,
          lineHeight: theme.typography.pxToRem(30),
        },
      },
    },
    primersCheckBoxfontWeight: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 'normal',
    },
    primersFilterFontSize: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 900,
    },
    primersFilterHeading: {
      paddingTop: theme.spacing(5),
    },
    SelectSpeciesBox: {
      border: `${theme.spacing(0.25)}px solid ${theme.palette.grey[400]}`,
      width: 900,
      margin: `${theme.spacing(0)}px ${theme.spacing(0)}px ${theme.spacing(
        0
      )}px ${theme.spacing(5)}px`,
      padding: `${theme.spacing(10)}px ${theme.spacing(8)}px ${theme.spacing(
        8
      )}px ${theme.spacing(6)}px`,
      height: 'fit-content',
    },
    marginTop3: {
      marginTop: theme.spacing(3),
    },
    marginTop2: {
      marginTop: theme.spacing(2),
    },
    marginRight3: {
      marginRight: theme.spacing(3),
    },
    height1: {
      height: theme.spacing(1),
    },
    geneArrayButton: {
      float: 'right',
      fontWeight: theme.typography.fontWeightMedium,
      marginLeft: theme.spacing(4),
    },
    downloadWrapper: {
      textAlign: 'left',
      display: 'flex',
    },
    downloadText: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
    },
    downloadicon: {
      color: theme.palette.primary.main,
      marginRight: theme.spacing(1),
    },
    marginBottom4: {
      marginBottom: theme.spacing(4),
    },
    width250: {
      width: 250,
    },
    floatRight: {
      float: 'right',
    },
    platesPadding: {
      padding: '4px 16px 4px 4px',
    },
    fontMedium: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    fontBold: {
      fontWeight: theme.typography.fontWeightBold,
    },
    helperTextError: {
      color: theme.palette.error.main,
      width: 350,
      fontSize: theme.typography.pxToRem(13),
      marginTop: theme.spacing(2),
      fontWeight: theme.typography.fontWeightRegular,
    },
    dropDownCSS: {
      '& .MuiAutocomplete-listbox': {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 5,
        position: 'absolute',
        zIndex: 1,
        maxHeight: theme.spacing(62.5),
        backgroundColor: theme.palette.common.white,
        marginTop: theme.spacing(-1),
      },
    },
    primerPairLabel: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.spacing(4),
    },
    addPlateTxt: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.spacing(3.5),
    },
    widthRankPrimers: {
      minWidth: theme.spacing(15),
    },
    widthSpeciesPrimers: {
      minWidth: theme.spacing(18.75),
    },
    errorMsg: {
      marginLeft: theme.spacing(-7.5),
    },
    errorBar: {
      marginLeft: theme.spacing(5),
    },
    geneArrayPaginationPadding: {
      paddingTop: theme.spacing(4),
    },
    primerPairIdCol: {
      width: '30%',
      wordBreak: 'break-word',
    },
    width5: {
      width: '5%',
    },
    width7: {
      width: '7%',
    },
    width12: {
      width: '12%',
    },
    width14: {
      width: '14%',
    },
    width20: {
      width: '20%',
    },
    headerMargin: {
      paddingLeft: theme.spacing(2.75),
    },
    fontQuote: {
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightBold,
    },
    blackColor: {
      color: theme.palette.text.primary,
    },
    marginLeftKicqstartPrimers: {
      marginLeft: theme.spacing(-1.75),
    },
    paddingKicqstartProbePrice: {
      padding: theme.spacing(1.25),
    },
    mTop12: {
      marginTop: theme.spacing(-3),
    },
    pdLeft: {
      paddingLeft: theme.spacing(2),
    },
    discountIcon: {
      width: 16,
      height: 16,
      marginTop: theme.spacing(0.5),
    },
    discountMsgCss: {
      height: 80,
      margin: '12px 0 12px 12px',
      border: `solid 1px ${theme.palette.vibrant.green}`,
      borderRadius: 4,
      backgroundColor: theme.palette.common.white,
      display: 'flex',
    },
    greenRectangle: {
      width: 5,
      height: 78,
      margin: '0 16px 0 0',
      backgroundColor: theme.palette.vibrant.green,
    },
    discountTxtCSS: {
      margin: '19px 0 26px 8px',
      fontFamily: 'Lato',
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightBold,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.46,
      letterSpacing: 'normal',
      textAlign: 'left',
      color: theme.palette.common.black,
    },
    tableContainer: {
      maxHeight: '400px',
    },
  }
})

export default useStyles
